import { render, staticRenderFns } from "./HomeSettings.vue?vue&type=template&id=02396608"
import script from "./HomeSettings.vue?vue&type=script&lang=js"
export * from "./HomeSettings.vue?vue&type=script&lang=js"
import style0 from "./HomeSettings.vue?vue&type=style&index=0&id=02396608&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports